/****************************************************************
 *  دیکشنری ترجمه (پایه)
 *    همه‌ی کلیدها lowercase هستند
 ****************************************************************/

const tvTranslations = {
  "Chart snapshot": "ثبت تصویر نمودار",
  "Download image": "دانلود تصویر",
  "Copy image": "کپی تصویر",
  "always show stats": "نمایش همیشگی آمار",
  "always visible": "همواره دیده شود",
  "anchored note": "یادداشت ثابت",
  "anchored text": "متن ثابت",
  "anchored vwap": "میانگین قیمت بر اساس وزن حجم معاملات",
  angle: "زاویه",
  angles: "زاوایا",
  "animals & nature": "حیوانات و طبیعت",
  "annotation tools": "ابزارهای حاشیه نویسی",
  "apply defaults": "اعمال پیش فرض ها",
  arc: "قوس",
  arcs: "قوس ها",
  area: "منطقه",
  arguments: "نمایش مقادیر ورودی ها",
  "horizontal ray": "نیم خط افقی",
  "trend line": "خط روند",
  "horizontal line": "خط افقی",
  ray: "نیم خط",
  "vertical line": "خط عمودی",
  "#{count} (bar)": "داده {count}",
  "#{count} (price, bar)": "نقطه {count}",
  "#1 (bar)": "داده",
  "#1 (price)": "قیمت",
  "#1 (price, bar)": "نقطه شروع",
  "{hotkey_0} — drawing a straight line at angles of 45":
    "جهت کشیدن خط مستقیم در زوایای 45 درجه {hotKey_0} را نگه دارید",
  "{hotkey_0} + click on the chart": "{hotKey_0} + کلیک روی نمودار",
  "{number} px :فاصله مختصات": "{number} px",
  "‎{status} p&l {pnl}‎": "‎{status} واقعی {pnl}‎",
  "{title} copy": "کپی {title}",
  "12-hours": "۱۲ ساعته",
  "24-hours": "۲۴ ساعته",
  "abcd pattern": "الگوی ABCD",
  "account size": "اندازه حساب",
  activity: "فعالیت",
  "add custom color": "افزودن رنگ سفارشی",
  "add custom interval": "افزودن تفکیک زمانی جدید",
  "add custom time interval": "افزودن تفکیک زمانی جدید",
  "add text": "افزودن متن",
  "add this indicator to favorites": "افزودن این اندیکاتور به مورد علاقه ها",
  "add to favorites": "افزودن به علاقه مندی ها",
  add: "افزودن",
  "added symbols": "نمادهای اضافه شده",
  "all changes saved": "تمام تغییرات ذخیره شد",
  "all intervals": "تمام بازه ها",
  "all sessions": "نمایش تمام جلسات",
  "always invisible": "همواره مخفی باشد",
  "always show stats": "نمایش همیشگی آمار",
  "always visible": "همواره دیده شود",
  "anchored note": "یادداشت ثابت",
  "anchored text": "متن ثابت",
  "anchored vwap": "میانگین قیمت بر اساس وزن حجم معاملات",
  angle: "زاویه",
  angles: "زوایا",
  "animals & nature": "حیوانات و طبیعت",
  "annotation tools": "ابزارهای حاشیه نویسی",
  "apply defaults": "اعمال پیش فرض ها",
  arc: "قوس",
  arcs: "قوس ها",
  area: "منطقه",
  arguments: "نمایش مقادیر ورودی ها",
  "arrow mark down": "فلش پایین",
  "arrow mark left": "فلش چپ",
  "arrow mark right": "فلش راست",
  "arrow mark up": "فلش بالا",
  "arrow marker": "فلش ساز",
  arrow: "فلش",
  arrows: "فلش ها",
  "auto (fits data to screen)": "خودکار (تناسب داده ها با صفحه نمایش)",
  auto: "خودکار",
  "avg hl in minticks": "میانگین HL در مین‌تیک‌ها",
  "background #1": "پس زمینه 1",
  background: "پس زمینه",
  "bands calculation mode": "حالت محاسبه باندها",
  "bands multiplier #1": "ضریب باند #1",
  "bands multiplier #2": "ضریب باند #2",
  "bands multiplier #3": "ضریب باند #3",
  "bands settings": "تنظیمات باندها",
  "bar change values": "نمایش میزان تغییر",
  "bars pattern": "الگوی نمودار",
  "bars range": "تعداد داده ها",
  bars: "میله ها",
  base: "پایه",
  baseline: "خط پایه",
  body: "بدنه",
  border: "مرز بدنه",
  borders: "مرزهای بدنه",
  "bottom labels": "برچسب های پایین",
  bottom: "پایین",
  "bring forward": "یک گام به جلو",
  "bring to front": "به ابتدا",
  brush: "قلم",
  brushes: "قلم ها",
  buttons: "دکمه ها",
  callout: "فراخوانی",
  cancel: "لغو",
  candles: "کندل ها",
  cando: "انجام می دهد",
  canvas: "صفحه نمودار",
  center: "مرکز",
  "change {pointindex} point": "تغییر {pointIndex} نقطه",
  "change {sourcetitle} title to {newsourcetitle}":
    "تغییر عنوان از {sourceTitle} به {newSourceTitle}",
  "change {title} background color": "تغییر رنگ پس زمینه {title}",
  "change {title} background visibility": "تغییر وضعیت نمایش پس زمینه {title}",
  "change {title} days from": "تغییر شروع روزها {title}",
  "change {title} days to": "تغییر پایان روزها {title}",
  "change {title} hours from": "تغییر شروع ساعات {title}",
  "change {title} hours to": "تغییر پایان ساعات {title}",
  "change {title} minutes from": "تغییر شروع دقایق {title}",
  "change {title} minutes to": "تغییر پایان دقایق {title}",
  "change {title} months from": "تغییر شروع ماه ها {title}",
  "change {title} months to": "تغییر پایان ماه ها {title}",
  "change {title} seconds from": "تغییر شروع ثانیه های {title}",
  "change {title} seconds to": "تغییر پایان ثانیه های {title}",
  "change {title} style": "تغییر سبک {title}",
  "change {title} visibility on {ranges}": "تغییر وضعیت نمایش {ranges} {title}",
  "change {title} visibility on days": "تغییر وضعیت نمایش روزها {title}",
  "change {title} visibility on hours": "تغییر وضعیت نمایش ساعات {title}",
  "change {title} visibility on minutes": "تغییر وضعیت نمایش دقایق {title}",
  "change {title} visibility on months": "تغییر وضعیت نمایش ماه ها {title}",
  "change {title} visibility on seconds": "تغییر وضعیت نمایش ثانیه ها {title}",
  "change {title} visibility on ticks": "تغییر وضعیت نمایش تیک ها {title}",
  "change {title} visibility on weeks": "تغییر وضعیت نمایش هفته ها {title}",
  "change {title} weeks from": "تغییر شروع هفته ها {title}",
  "change {title} weeks to": "تغییر پایان هفته ها {title}",
  "change {toolname} labels alignment horizontal":
    "تغییر تراز افقی برچسب های {toolName}",
  "change {toolname} labels alignment vertical":
    "تغییر تراز عمودی برچسب های {toolName}",
  "change {toolname} labels direction": "تغییر جهت برچسب های {toolName}",
  "change {toolname} line color": "تغییر رنگ خط {toolName}",
  "change {toolname} line extending left": "تغییر امتداد سمت چپ خط {toolName}",
  "change {toolname} line extending right":
    "تغییر امتداد سمت راست خط {toolName}",
  "change {toolname} line left end": "تغییر پایان سمت چپ خط {toolName}",
  "change {toolname} line right end": "تغییر پایان سمت راست خط {toolName}",
  "change {toolname} line style": "تغییر نوع خط {toolName}",
  "change {toolname} line visibility": "تغییر وضعیت دیده شدن خط {toolName}",
  "change {toolname} line width": "تغییر ضخامت خط {toolName}",
  "change {toolname} text background color":
    "تغییر رنگ پس زمینه متن {toolName}",
  "change {toolname} text background visibility":
    "تغییر وضعیت دیده شدن پس زمینه متن {toolName}",
  "change {toolname} text border color": "تغییر رنگ مرز متن {toolName}",
  "change {toolname} text border visibility":
    "تغییر وضعیت دیده شدن مرز متن {toolName}",
  "change {toolname} text border width": "تغییر ضخامت مرز متن {toolName}",
  "change {toolname} text color": "تغییر رنگ متن {toolName}",
  "change {toolname} text font bold": "تغییر پررنگ سازی حروف متن {toolName}",
  "change {toolname} text font italic": "تغییر مورب سازی حروف متن {toolName}",
  "change {toolname} text font size": "تغییر اندازه حروف متن {toolName}",
  "change {toolname} text visibility": "تغییر وضعیت دیده شدن متن {toolName}",
  "change {toolname} text wrap": "تغییر وضعیت متن در کادر {toolName}",
  "change {toolname} text": "تغییر متن {toolName}",
  "change date range": "تغییر بازه زمانی",
  "change in pips": "تغییر پیپ ها",
  "change interval": "تغییر تفکیک زمانی",
  "change line tool(s) background color": "تغییر پس زمینه",
  "change line tool(s) color": "تغییر رنگ خط",
  "change line tool(s) line style": "تغییر سبک خط",
  "change line tool(s) line width": "تغییر ضخامت خط",
  "change resolution": "تغییر تفکیک زمانی",
  "change series style": "تغییر سبک نمودار",
  "change symbol": "تغییر نماد",
  "change timezone": "تغییر منطقه زمانی",
  channel: "کانال",
  channels: "کانال ها",
  "chart basic styles": "تنظیمات پایه",
  "chart settings": "تنظیمات نمودار",
  "chart values": "نمایش مقادیر نمودار",
  circle: "دایره",
  clone: "شبیه سازی",
  "close menu": "بستن",
  "coeffs as percents": "ضرایب به عنوان درصدها",
  "collapse pane": "جمع کردن پنل",
  "color 0": "رنگ 0",
  "color 1": "رنگ 1",
  "color bars based on previous close":
    "رنگ میله ها بر اساس آخرین مقدار قبلی باشد",
  color: "رنگ",
  columns: "ستون ها",
  comment: "نظر",
  "compact stats mode": "حالت آمار جمع و جور",
  "compare or add symbol": "مقایسه یا افزودن نماد",
  "compare symbol": "مقایسه نماد",
  confirmation: "تاییدیه",
  coordinates: "مختصات",
  "copy chart layout": "ایجاد کپی جدید از تحلیل",
  "copy price": "کپی قیمت",
  copy: "کپی کردن",
  "countdown to bar close": "شمارش معکوس تا بسته شدن آخرین داده",
  counterclockwise: "پادساعتگرد",
  "create {tool}": "ایجاد {tool}",
  "create a group of drawings": "ایجاد یک گروه اشیاء",
  "cross line": "خط متقاطع",
  cross: "متقاطع",
  crosshair: "تقاطع",
  currency: "واحد پول",
  "current interval and above": "بازه فعلی و بالاتر",
  "current interval and below": "بازه فعلی و کمتر",
  "current interval only": "تنها در بازه فعلی",
  cursors: "نشانگرها",
  curve: "منحنی",
  "custom range": "بازه زمان",
  cycles: "چرخه ها",
  "cyclic lines": "خطوط چرخه ای",
  "cypher pattern": "الگوی سایفر",
  d: "روز",
  "dashed line": "خط بریده بریده",
  "data modification": "اصلاح داده ها",
  "date and price range": "بازه زمان و قیمت",
  "date modified (newest first)": "جدیدترین ویرایش",
  "date modified (oldest first)": "قدیمی ترین ویرایش",
  "date range": "بازه زمان",
  "date/time range": "نمایش تغییر زمان",
  date: "تاریخ",
  day: "روز",
  "days from": "از روز",
  "days to": "روز به",
  days: "روز",
  default: "پیش فرض",
  defaults: "پیش فرض ها",
  degree: "درجه",
  "delete pane": "حذف پنل",
  delta: "دلتا",
  description: "عنوان",
  "developing poc": "روند POC",
  "developing va": "روند VA",
  "disjoint channel": "کانال نامتصل",
  distance: "فاصله",
  dot: "نقطه",
  "dotted line": "خط نقطه چین",
  "double click": "دو بار کلیک",
  "double curve": "منحنی دوگانه",
  "double-click to finish path": "برای پایان مسیر دوبار کلیک کنید",
  "double-click to finish polyline": "برای پایان چند وجهی دوبار کلیک کنید",
  "down volume": "حجم منفی",
  down: "پایین",
  drawings: "ابزارها ",
  "elliott correction wave (abc)": "موج اصلاحی الیوت (ABC)",
  "elliott double combo wave (wxy)": "موج ترکیبی دوگانه الیوت (WXY)",
  "elliott impulse wave (12345)": "موج تحریک الیوت (12345)",
  "elliott triangle wave (abcde)": "موج مثلثی الیوت (ABCDE)",
  "elliott triple combo wave (wxyxz)": "موج ترکیبی سه گانه الیوت (WXYXZ)",
  "elliott waves": "امواج الیوت",
  ellipse: "بیضی",
  "emoji pin": "سنجاق کردن شکلک",
  emoji: "شکلک",
  emojis: "ایموجی ها",
  "enter a new chart layout name": "یک نام جدید وارد کنید",
  "entry price": "قیمت ورودی",
  eraser: "پاک کن",
  "exchange timezone": "منطقه زمانی معاملات",
  exchange: "بورس",
  "existing pane above": "بالا",
  "existing pane below": "پایین",
  "extend bottom": "پایین امتداد داده شود",
  "extend left line": "امتداد سمت چپ",
  "extend left": "سمت چپ امتداد داده شود",
  "extend lines left": "خطوط سمت چپ امتداد داده شود",
  "extend lines right": "خطوط سمت راست امتداد داده شود",
  "extend lines": "نمایش امتداد خطوط",
  "extend right line": "امتداد سمت راست",
  "extend right": "سمت راست امتداد داده شود",
  "extend top": "بالا امتداد داده شود",
  extend: "نمایش امتداد",
  "extended line": "خط ممتد",
  fans: "زوایای گن",
  "fib channel": "کانال فیبوناچی",
  "fib circles": "دایره های فیبوناچی",
  "fib levels based on log scale": "سطوح فیبوناچی بر اساس مقیاس لگاریتمی",
  "fib retracement": "بازگشت فیبوناچی",
  "fib speed resistance arcs": "قوس های مقاومت سرعت فیبوناچی",
  "fib speed resistance fan": "بادبزن مقاومت سرعت فیبوناچی",
  "fib spiral": "مارپیچ فیبوناچی",
  "fib time zone": "مناطق زمانی فیبوناچی",
  "fib wedge": "سه گوش فیبوناچی",
  fibonacci: "فیبوناچی",
  "fixed range volume profile": "پروفایل حجمی در بازه زمانی ثابت",
  "flag mark": "نشان پرچم",
  flags: "پرچم ها",
  "flat top/bottom": "بالا یا پایین صاف",
  flipped: "وارونه",
  "font size": "اندازه قلم",
  "food & drink": "غذا نوشیدنی",
  forecast: "پیش بینی",
  "forecasting and measurement tools": "ابزارهای اندازه گیری و پیش بینی",
  fri: "جمعه",
  "full circles": "دایره های کامل",
  function: "دستورات",
  "gann and fibonacci tools": "ابزارهای گن و فیبوناچی",
  "gann box": "جعبه گن",
  "gann fan": "بادبزن گن",
  "gann square fixed": "مربع ثابت گن",
  "gann square": "مربع گن",
  gann: "گن",
  "geometric shapes": "اَشکال هندسی",
  "gestures & smileys": "شکلک ها و ژست ها",
  "ghost feed": "داده های فرضی",
  "go to": "انتخاب تاریخ",
  gradient: "تغییر تدریجی",
  "grid lines": "خطوط شبکه",
  grid: "شبکه",
  "head and shoulders": "الگوی سر و شانه",
  head: "سر",
  "heikin ashi": "هِیکن آشی",
  hidden: "مخفی",
  "hide all drawings and indicators": "پنهان کردن اندیکاتورها و اشکال رسم شده",
  "hide all drawings": "پنهان کردن اشکال رسم شده",
  "hide all indicators": "پنهان کردن اندیکاتورها",
  "hide all": "پنهان کردن اندیکاتورها و اشکال رسم شده",
  "hide drawings toolbar": "پنهان کردن نوار ابزار ترسیم",
  "hide drawings": "پنهان کردن اشکال رسم شده",
  "hide indicator legend": "پنهان کردن راهنمای  اندیکاتور",
  "hide indicators": "پنهان کردناندیکاتورها",
  "hide marks on bars": "مخفی کردن علائم روی نمودار",
  "hide options": "مخفی کردن گزینه ها",
  hide: "مخفی",
  "high and low price labels": "نمایش بیشترین و کمترین قیمت",
  "high and low price lines": "نمایش خطوط بیشترین و کمترین قیمت در صفحه",
  "high and low": "نمایش بیشترین و کمترین قیمت",
  highlighter: "قلم پس زمینه",
  "high-low": "بالاترین-پایین ترین",
  "histogram box": "کادر",
  "hlc area": "منطقه HLC",
  "hollow candles": "کندل های توخالی",
  "horizontal line": "خط افقی",
  "horizontal ray": "خط پرتو افقی",
  horizontal: "افقی",
  "horz only": "فقط افقی",
  hour: "ساعت",
  "hours from": "از ساعت",
  "hours to": "ساعت به",
  hours: "ساعت",
  icon: "نماد",
  icons: "نمادها",
  in: "در",
  "indexed to 100": "شروع از ۱۰۰",
  "indicator arguments": "ورودی های اندیکاتورها",
  "indicator templates": "قالب های اندیکاتور",
  "indicator titles": "عناوین اندیکاتورها",
  "indicator values": "مقادیر اندیکاتورها",
  "indicators & strategies": "اندیکاتورها",
  "indicators and financials": "اندیکاتورها و مالی",
  "indicators name labels": "نمایش نام اندیکاتورها",
  "indicators value labels": "نمایش مقدار اندیکاتورها",
  indicators: "اندیکاتورها",
  "info line": "خط اطلاعات",
  inputs: "ورودی ها",
  "insert {title}": "درج {title}",
  "inside pitchfork": "چنگال داخلی",
  inside: "داخلی",
  interval: "تفکیک زمانی",
  "invert scale": "مقیاس معکوس",
  "label background": "برچسب پس زمینه",
  "label border": "مرز برچسب",
  "label text": "متن برچسب",
  label: "برچسب",
  "labels on price scale": "برچسب ها در نوار قیمت",
  labels: "برچسب ها",
  "layout name (a to z)": "نام تحلیل",
  "layout name (z to a)": "نام تحلیل برعکس",
  "layout name": "نام تحلیل",
  "left labels": "برچسب های سمت چپ",
  "left shoulder": "شانه چپ",
  left: "چپ",
  "levels line": "خط سطوح",
  levels: "سطوح",
  "line color": "رنگ خط",
  "line tool backgrounds": "پس زمینه",
  "line tool colors": "رنگ خط",
  "line tool width": "خط با نشانگرها",
  "line with markers": "خط با نشانگرها",
  line: "خط",
  lines: "خطوط",
  "listed exchange": "بورس فهرست شده",
  "load layout": "بارگذاری تحلیل",
  "lock {title}": "قفل کردن {title}",
  "lock all drawings": "قفل کردن تمام اشکال رسم شده",
  "lock price to bar ratio": "قفل کردن قیمت بر روی نسبت داده",
  "lock vertical cursor line by time": "خط نشانگر عمودی بر اساس زمان قفل شود",
  lock: "قفل کردن",
  log: "لگاریتمی",
  logarithmic: "لگاریتمی",
  "long position": "وضعیت خرید",
  "lot size": "اندازه لات",
  "lower band #1": "باند پایین 1",
  "lower band #2": "باند پایین 2",
  "lower band #3": "باند پایین 3",
  "lower deviation": "انحراف پایین",
  m: "ماه",
  "magnet mode snaps drawings placed near price bars to the closest ohlc value":
    "حالت چسبندگی، در هنگام ترسیم، نقاط نزدیک به نمودار را به نزدیک ترین مقدار روی نمودار می چسباند",
  magnets: "چسبندگی",
  "make a copy": "ایجاد کپی جدید از تحلیل",
  "manage layouts": "مدیریت تحلیل ها",
  margins: "حاشیه ها",
  "market closed": "بازار بسته است",
  "market open": "بازار باز است",
  "maximize pane": "بزرگ کردن",
  measure: "اندازه گیری",
  measurer: "اندازه گیر",
  median: "میانه",
  "merge all scales into one": "ادغام تمام مقیاس ها با هم",
  "middle line": "خط وسط",
  "middle point": "نقطه وسط",
  middle: "وسط",
  minute: "دقیقه",
  "minutes from": "از دقیقه",
  "minutes to": "دقیقه به",
  minutes: "دقیقه",
  mirrored: "منعکس شده",
  mode: "حالت",
  "modified schiff pitchfork": "چنگال شیف تغییر یافته",
  "modified schiff": "شیف تغییر یافته",
  mon: "دوشنبه",
  month: "ماه",
  "months from": "از ماه",
  "months to": "ماه به",
  months: "ماه",
  "more settings": "تنظیمات بیشتر",
  more: "بیشتر",
  "move pane down": "انتقال به بالا",
  "move pane up": "انتقال به پایین",
  "move scale to left": "انتقال مقیاس به چپ",
  "move scale to right": "انتقال مقیاس به راست",
  "move to": "انتقال به",
  "my templates": "قالب های من",
  name: "نام",
  nature: "طبیعت",
  navigation: "جهت یابی",
  "new pane above": "پنل جدید بالا",
  "new pane below": "پنل جدید پایین",
  "new pane": "پنل جدید",
  "new price scale": "نوار قیمت جدید",
  "no overlapping labels": "بدون همپوشانی برچسب ها",
  "no overlapping": "بدون همپوشانی برچسب ها",
  "no scale (fullscreen)": "بدون نوار وضعیت (تمام صفحه)",
  "no symbols here yet — why not add some?": "نمادی افزوده نشده",
  "no volume data": "بدون حجم معاملات",
  no: "خیر",
  none: "هیچکدام",
  note: "یادداشت",
  "number of rows": "تعداد ردیف‌ها",
  "object tree": "درخت اشیاء",
  objects: "اشیاء",
  ok: "تایید",
  "on the left": "در سمت چپ",
  "on the right": "در سمت راست",
  opacity: "وضوح",
  original: "اصلی",
  outputs: "خروجی ها",
  "override min tick": "بازنویسی حداقل تیک",
  "pane separators": "جداکننده ی پنل ها",
  pane: "پنل",
  "parallel channel": "کانال موازی",
  paste: "چسباندن",
  path: "مسیر",
  patterns: "اگوها",
  "pearson\'s r": "نمایش مقدار پیرسون",
  "percent change": "تغییر قیمت به درصد",
  percent: "درصد",
  percentage: "درصد",
  percents: "درصدها",
  "pin to new left scale": "چسباندن به نوار قیمت چپ جدید",
  "pin to new right scale": "چسباندن به نوار قیمت راست جدید",
  "pin to scale (now {label})": "چسباندن به نوار قیمت {label}",
  "pin to scale (now left)": "چسباندن به نوار قیمت چپ",
  "pin to scale (now right)": "چسباندن به نوار قیمت راست",
  "pin to scale {label}": "چسباندن به نوار قیمت {label}",
  "pinned to left scale": "به نوار قیمت چپ چسبیده",
  "pinned to right scale": "به نوار قیمت راست چسبیده",
  "pinned to scale {label}": "به نوار قیمت {label} چسبیده",
  pitchfan: "بادبزن شیب",
  pitchfork: "چنگال",
  pitchforks: "چنگال ها",
  placement: "محل قرارگیری",
  plot: "نمودار",
  "plus button": "نمایش دکمه (+)",
  "point value": "_",
  point: "نقطه",
  polyline: "چند وجهی",
  "post-market": "پس از بسته شدن",
  precision: "دقت",
  "pre-market": "پیش گشایش",
  "press and hold {key} while zooming to maintain the chart position":
    "برای حفظ موقعیت نمودار، هنگام بزرگ نمایی، دکمه {key} را فشار داده و نگه دارید",
  "price and percentage value": "قیمت و درصد",
  "price label": "برچسب قیمت",
  "price labels & lines": "برچسب های قیمت و خطوط",
  "price labels": "برچسب های قیمت",
  "price levels": "سطوح قیمت",
  "price line": "نمایش خط آخرین قیمت",
  "price note": "یادداشت قیمت",
  "price range": "بازه قیمت",
  "price scale": "نوار قیمت",
  "price source": "مرجع قیمت",
  "price/bar ratio": "ضریب قیمت/داده",
  price: "قیمت",
  prices: "قیمت ها",
  "profit level": "سطح سود",
  projection: "پیش بینی روند",
  property: "خصوصیت",
  "qty: {qty}": "تعداد: {qty}",
  "quick search": "جستجوی سریع",
  "ranges and ratio": "بازه‌ها و نسبت",
  ray: "خط پرتو",
  "recent search": "جستجوی اخیر",
  "recent symbols": "نمادهای اخیر",
  "recently used": "اخیراً استفاده شده",
  rectangle: "مستطیل",
  "regression trend": "روند رگرسیون",
  regular: "منظم",
  "remember interval": "تفکیک زمانی نیز در قالب ذخیره شود",
  "remember symbol": "شناسه نماد نیز در قالب ذخیره شود (غیرفعال)",
  "remove {drawings} & {indicators}": "حذف تمام اندیکاتورها و اشکال رسم شده",
  "remove {drawings}": "حذف {drawings}",
  "remove {indicators}": "حذف {indicators}",
  "remove {title}": "حذف {title}",
  "remove all studies and drawing tools":
    "حذف تمام اندیکاتورها و اشکال رسم شده",
  "remove all studies": "حذف تمام اندیکاتورها",
  "remove drawings": "حذف اشکال رسم شده",
  "remove from favorites": "حذف از علاقه مندی ها",
  "remove indicators": "حذف اندیکاتورهای رسم شده",
  "remove options": "حذف گزینه ها",
  "remove this indicator from favorites": "حذف این اندیکاتور از مورد علاقه ها",
  remove: "حذف",
  "rename chart layout": "تغییر نام تحلیل",
  rename: "تغییر نام تحلیل",
  "reset chart view": "بازنشانی نمای نمودار",
  "reset price scale": "بازنشانی نوار قیمت",
  "reset settings": "بازنشانی تنظیمات",
  "restore pane": "بازگشت به اندازه اولیه",
  reverse: "معکوس",
  "right labels": "برچسب های سمت راست",
  "right shoulder": "شانه راست",
  right: "راست",
  risk: "ریسک",
  "rotated rectangle": "مستطیل چرخشی",
  "row size": "اندازه ردیف",
  "rows layout": "چیدمان ردیف‌ها",
  "same % scale": "نوار قیمت کنونی به درصد",
  sat: "شنبه",
  "save all charts for all symbols and intervals on your layout": "ذخیره تحلیل",
  "save as default": "ذخیره به عنوان پیش فرض",
  "save indicator template": "ذخیره قالب اندیکاتور",
  "save layout": "ذخیره تحلیل",
  "save new chart layout": "ذخیره تحلیل جدید",
  save: "ذخیره",
  "saved indicators": "اندیکاتورهای ذخیره شده",
  "scale modes (a and l)": "حالات مقیاس (A و L)",
  "scale price chart only": "فقط نسبت قیمت نمودار",
  "scales and lines": "مقیاس ها و خطوط",
  "scales placement": "محل نوار قیمت",
  scales: "مقیاس ها",
  "schiff pitchfork": "چنگال شیف",
  schiff: "شیف",
  "script name": "نام اندیکاتورها",
  "scroll to the left": "پیمایش به چپ",
  "scroll to the most recent bar": "پیمایش به آخرین داده",
  "scroll to the right": "پیمایش به راست",
  scroll: "پیمایش",
  "search tool or function": "جستجوی ابزارها، دستورات و تنظیمات",
  search: "جستجو",
  "seconds to": "ثانیه به",
  seconds: "ثانیه",
  "security info": "اطلاعات نماد",
  "selecting this option will set the {interval} interval on the chart when this template is applied":
    "با انتخاب این گزینه، زمانی که این الگو اعمال می شود، تفکیک زمانی {interval} نیز در نمودار تنظیم می شود",
  "selecting this option will set the {symbol} symbol on the chart when this template is applied":
    "با انتخاب این گزینه، زمانی که این الگو اعمال می شود، شناسه نماد کنونی نیز در نمودار تنظیم می شود",
  "send backward": "یک گام به عقب",
  "send to back": "به انتها",
  session: "جلسه معاملات",
  "session breaks": "خط جداکننده تفکیک زمانی",
  settings: "تنظیمات",
  shapes: "اشکال",
  "short position": "وضعیت فروش",
  "show all drawings and indicators": "نمایش اندیکاتورها و اشکال رسم شده",
  "show all drawings": "نمایش اشکال رسم شده",
  "show all indicators": "نمایش اندیکاتورها",
  "show drawings toolbar": "نمایش نوار ابزار ترسیم",
  "show favorite drawing tools toolbar": "نمایش نوار ابزار طراحی مورد علاقه",
  "show indicator legend": "نمایش راهنمای  اندیکاتور",
  "show object tree": "نمایش درخت اشیاء",
  show: "نمایش",
  signpost: "علامت گذاری",
  "sine line": "خط سینوسی",
  "smiles & people": "شکلک ها و ژست ها",
  solid: "یکدست",
  "sort by layout name, date changed": "مرتب سازی",
  source: "منبع",
  "stack on the left": "چپ",
  "stack on the right": "راست",
  "standard deviation": "انحراف معیار",
  "stats position": "مکان نمایش آمار",
  stats: "آمار",
  "status line": "خط وضعیت",
  "stay in drawing mode": "در حالت ترسیم بمانید",
  "step line": "خط پله ای",
  stickers: "برچسب ها",
  "stop color": "رنگ توقف",
  "stop level": "سطح توقف",
  "stop: {stopchange} ({stopchangepercent}) {stopchangepip}, amount: {amount}":
    "استاپ: {stopChange} ({stopChangePercent}) {stopChangePip}, مقدار: {amount}",
  "strong magnet": "چسبندگی قوی",
  style: "سبک",
  sun: "یکشنبه",
  "symbol & description": "نماد و توضیحات",
  "symbol last price label": "نمایش آخرین قیمت",
  "symbol name label": "نمایش نام نماد",
  "symbol search": "جستجوی نماد",
  "symbol title": "عنوان نماد",
  symbol: "نماد",
  "symbols & flags": "نمادها و پرچم ها",
  symbols: "نمادها",
  "template name": "نام قالب",
  template: "قالب",
  "text & notes": "متن و یادداشت ها",
  "text alignment": "تراز متن",
  "text orientation": "جهت متن",
  "text wrap": "قراردادن متن در کادر",
  text: "متن",
  "the data vendor doesn\'t provide volume data for this symbol.":
    "این نماد حجم معاملات مشخصی ندارد.",
  thickness: "ضخامت",
  "three drives pattern": "الگوی سه موج (تری درایو)",
  thu: "پنجشنبه",
  "tick size": "اندازه کوچکترین واحد",
  "ticker and description": "شناسه و عنوان",
  ticker: "شناسه",
  "ticks per row": "تیک در هر ردیف",
  ticks: "تیک",
  "time cycles": "چرخه های زمانی",
  "time hours format": "قالب نمایش ساعت",
  "time label": "برچسب زمان",
  "time levels": "برچسب های زمان",
  "time scale": "نوار زمان",
  timezone: "منطقه زمانی",
  title: "نمایش عنوان",
  titles: "نمایش عناوین",
  "toggle auto scale": "تغییر مقیاس خودکار",
  "toggle log scale": "تغییر مقیاس لگاریتمی",
  "toggle percentage": "تغییر نمایش به درصد",
  "top labels": "برچسب های بالا",
  top: "بالا",
  total: "کل",
  transparency: "شفافیت",
  "travel & places": "سفر و مکان ها",
  "trend angle": "زاویه روند",
  "trend line tools": "ابزارهای خط روند",
  "trend line": "خط روند",
  "trend-based fib extension": "گسترش فیبوناچی مبتنی بر روند",
  "trend-based fib time": "مناطق زمانی فیبوناچی مبتنی بر روند",
  "triangle pattern": "الگوی مثلث",
  triangle: "مثلث",
  tue: "سه‌شنبه",
  "type the interval number for minute charts (i.e. 5 if it is going to be a five minute chart). or number plus letter for h (hourly), d (daily), w (weekly), m (monthly) intervals (i.e. d or 2h)":
    "برای نمودارهای دقیقه ای، شماره تفکیک زمانی را وارد کنید (مثلاً 5 اگر قرار است نمودار پنج دقیقه ای باشد). یا شماره به همراه حرف برای بازه های زمانی H (ساعتی), D (روزانه), W (هفتگی), M (ماهانه) (مثلاً D یا 2H)",
  "type to search for drawings, functions and settings": "شروع به نوشتن کنید",
  type: "نوع",
  unlock: "باز کردن",
  "up volume": "حجم مثبت",
  "up/down": "بالا/پایین",
  up: "بالا",
  "upper band #1": "باند بالا 1",
  "upper band #2": "باند بالا 2",
  "upper band #3": "باند بالا 3",
  "upper deviation": "انحراف بالا",
  "use lower deviation": "استفاده از انحراف پایین",
  "use one color": "استفاده از تک رنگ",
  "use upper deviation": "استفاده از انحراف بالا",
  "value according to scale": "ارزش بر اساس مقیاس",
  "value area down": "مقدار منطقه منفی",
  "value area up": "مقدار منطقه مثبت",
  "value area volume": "حجم منطقه ارزش",
  value: "مقدار",
  "values in status line": "مقادیر در خط وضعیت",
  values: "نمایش مقادیر",
  variance: "واریانس",
  "vert and horz": "عمودی و افقی",
  "vert only": "فقط عمودی",
  "vertical line": "خط عمودی",
  vertical: "عمودی",
  "visibility on intervals": "نمایش در بازه های زمانی",
  visibility: "دید",
  "visible on mouse over": "نمایش با قرارگیری موس",
  "visual order": "ترتیب دیده شدن",
  "volume profile": "نمودار حجم",
  volume: "حجم",
  "volume-based": "مبتنی بر حجم",
  w: "هفته",
  watermark: "واترمارک",
  wave: "موج",
  "weak magnet": "چسبندگی ضعیف",
  wed: "چهارشنبه",
  week: "هفته",
  "weeks from": "از هفته",
  "weeks to": "هفته به",
  weeks: "هفته",
  wick: "سایه",
  "width (% of the box)": "عرض (درصد از کادر)",
  "xabcd pattern": "الگوی XABCD",
  years: "سال ها",
  yes: "بله",
  "zoom in": "بزرگ نمایی",
  "zoom out": "کوچک نمایی",
  zoom: "ابزار ذره بین",
};

/****************************************************************
 * 4. موتور یافتن ترجمه (هوشمند)
 ****************************************************************/

function normalizeKey(s) {
  return s.trim().replace(/\s+/g, " ").toLowerCase();
}

/**
 * resolveTranslation
 * - ورودی: هر متن خام (مثل "Horizontal Ray", "Horizontal Ray (Alt+H)", "  HORIZONTAL  RAY ")
 * - خروجی: ترجمه‌ی مناسب، یا null
 */
/*
function resolveTranslation(text) {
  if (!text) return null;

  const raw = text;
  const cleaned = raw.trim();
  if (!cleaned) return null;

  const norm = normalizeKey(cleaned);

  // 1. match مستقیم
  if (Object.prototype.hasOwnProperty.call(tvTranslations, norm)) {
    return tvTranslations[norm];
  }

  // 2. اگر متن شامل shortcut / پرانتز بود: قبل از پرانتز را بگیر
  //    مثال: "Horizontal Ray (Alt+H)" => "horizontal ray"
  const mainPartMatch = cleaned.match(/^([^(]+)/);
  if (mainPartMatch && mainPartMatch[1]) {
    const mainPart = normalizeKey(mainPartMatch[1]);
    if (Object.prototype.hasOwnProperty.call(tvTranslations, mainPart)) {
      const translatedMain = tvTranslations[mainPart];
      const rest = cleaned.substring(mainPartMatch[1].length); // شامل " (Alt+H)"
      return translatedMain + rest;
    }
  }

  // 3. partial match روی کلیدها (خیلی تهاجمی – مراقب باش)
  for (const key in tvTranslations) {
    if (!Object.prototype.hasOwnProperty.call(tvTranslations, key)) continue;
    if (!key) continue;
    if (norm.includes(key)) {
      // مثال: "Draw Horizontal Ray" و کلید "horizontal ray"
      const translatedPart = tvTranslations[key];
      return cleaned.replace(new RegExp(key, "ig"), translatedPart);
    }
  }

  return null;
}*/
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// TradingView deliberately uses case-sensitive compact units: `m` means
// minute while `M` means month. These tokens must be handled before the
// lowercase dictionary lookup, otherwise selecting 1 minute renders 1 month.
const exactChartUnits = {
  m: " دقیقه",
  h: " ساعت",
  D: " روز",
  W: " هفته",
  M: " ماه",
  "{count}m": "{count} ماه",
  "{count}d": "{count} روز",
};

function resolveTranslation(text) {
  if (!text) return null;

  const cleaned = text.trim();
  if (!cleaned) return null;

  if (Object.prototype.hasOwnProperty.call(exactChartUnits, cleaned)) {
    return exactChartUnits[cleaned];
  }

  const norm = normalizeKey(cleaned);

  // 1. match مستقیم
  if (Object.prototype.hasOwnProperty.call(tvTranslations, norm)) {
    return tvTranslations[norm];
  }

  // 2. اگر متن شامل shortcut / پرانتز بود: قبل از پرانتز را بگیر
  const mainPartMatch = cleaned.match(/^([^(]+)/);
  if (mainPartMatch && mainPartMatch[1]) {
    const mainPartRaw = mainPartMatch[1].trim();
    const mainPart = normalizeKey(mainPartRaw);

    if (Object.prototype.hasOwnProperty.call(tvTranslations, mainPart)) {
      const translatedMain = tvTranslations[mainPart];
      const rest = cleaned.substring(mainPartRaw.length);
      return translatedMain + rest;
    }
  }

  // 3. partial match فقط برای ورودی تک‌کلمه‌ای
  // اگر متن چندکلمه‌ای است، دیگر داخلش چیزی را ترجمه نکن
  if (/\s/.test(cleaned)) {
    return null;
  }

  for (const key in tvTranslations) {
    if (!Object.prototype.hasOwnProperty.call(tvTranslations, key)) continue;
    if (!key) continue;

    const escapedKey = escapeRegExp(key);
    const regex = new RegExp(`\\b${escapedKey}\\b`, "i");

    if (regex.test(norm)) {
      return tvTranslations[key];
    }
  }

  return null;
}

/****************************************************************
 * 5. custom_translate_function
 ****************************************************************/
function customTranslate(originalText, singularOriginalText, translatedText) {
  const src = originalText || singularOriginalText || "";
  if (!src) return translatedText || originalText || singularOriginalText || "";

  // لاگ برای دیباگ – اگر خواستی کم‌اش کن
  if (src.toLowerCase().includes("horizontal ray")) {
    console.log("[TV custom_translate] called for:", {
      originalText,
      singularOriginalText,
      translatedText,
    });
  }

  const fromMap = resolveTranslation(src);
  if (fromMap != null) {
    return fromMap;
  }

  // چند case نمونه
  switch (src) {
    case "m":
      return "دقیقه";
    case "Standard Deviation":
      return null; // اجازه بده TV خودش مدیریت کند
    default:
      break;
  }

  return translatedText || src;
}

// The chart bootstrap reads this exact global before constructing the widget.
// Export explicitly instead of relying on browser-specific global function
// declaration behavior.
window.customTranslate = customTranslate;

/****************************************************************
 * 6. ترجمه‌ی DOM (TextNodes + title + aria-label + data-tooltip)
 ****************************************************************/

function translateTextNode(node) {
  const original = node.nodeValue;
  if (!original || !original.trim()) return false;

  const translated = resolveTranslation(original);
  if (translated && translated !== original) {
    node.nodeValue = translated;
    console.log(
      "[DOM text translated]",
      JSON.stringify(original),
      "=>",
      JSON.stringify(translated),
    );
    return true;
  }
  return false;
}

function translateAttribute(el, attrName) {
  const original = el.getAttribute(attrName);
  if (!original) return false;

  const translated = resolveTranslation(original);
  if (translated && translated !== original) {
    el.setAttribute(attrName, translated);
    console.log(
      `[DOM attr translated] ${attrName}:`,
      JSON.stringify(original),
      "=>",
      JSON.stringify(translated),
    );
    return true;
  }
  return false;
}

function translateAllExisting() {
  // Text nodes
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) {
          return NodeFilter.FILTER_REJECT;
        }
        const parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        const tag = parent.nodeName.toLowerCase();
        if (["script", "style", "noscript"].includes(tag)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    },
    false,
  );

  let n;
  let changed = 0;
  while ((n = walker.nextNode())) {
    if (translateTextNode(n)) changed++;
  }

  // Attributeها
  const attrNames = ["title", "aria-label", "data-tooltip"];
  let attrChanged = 0;
  const elements = document.querySelectorAll("*");
  elements.forEach((el) => {
    attrNames.forEach((attr) => {
      if (translateAttribute(el, attr)) attrChanged++;
    });
  });

  console.log(
    `[DOM initial translation] textNodes changed=${changed}, attributes changed=${attrChanged}`,
  );
}

/**
 * MutationObserver برای ترجمه‌ی هر تغییری که بعداً در UI رخ می‌دهد
 */
function setupDomTranslationObserver() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      // تغییر در childها
      if (m.type === "childList") {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            translateTextNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            // TextNodes زیر این node
            const walker = document.createTreeWalker(
              node,
              NodeFilter.SHOW_TEXT,
              {
                acceptNode(n) {
                  if (!n.nodeValue || !n.nodeValue.trim()) {
                    return NodeFilter.FILTER_REJECT;
                  }
                  const p = n.parentNode;
                  if (!p) return NodeFilter.FILTER_REJECT;
                  const tag = p.nodeName.toLowerCase();
                  if (["script", "style", "noscript"].includes(tag)) {
                    return NodeFilter.FILTER_REJECT;
                  }
                  return NodeFilter.FILTER_ACCEPT;
                },
              },
              false,
            );
            let tn;
            while ((tn = walker.nextNode())) {
              translateTextNode(tn);
            }

            // Attributeهای مهم
            ["title", "aria-label", "data-tooltip"].forEach((attr) => {
              translateAttribute(node, attr);
            });
          }
        });
      }

      // تغییر در attribute
      if (m.type === "attributes") {
        if (["title", "aria-label", "data-tooltip"].includes(m.attributeName)) {
          translateAttribute(m.target, m.attributeName);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["title", "aria-label", "data-tooltip"],
  });

  console.log("[DOM translator] MutationObserver is active");
}
